import React, { Component } from 'react';
import './SliderKey.css';

class SliderKey extends Component {
  render() {
    return (
      <div
        className="sliderKeyBorder"
        style={{ paddingTop: '50px', paddingLeft: '20px' }}
      >
        <div className="rowLayout">
          <div className="col-12">
            <h5 className="slider_legendtitle">Slider Key</h5>
          </div>
        </div>
        <div
          className="rowLayout"
          style={{ marginBottom: '1em', marginTop: '-1em' }}
        >
          <div className="col-6 centerbox">
            <div>
              <div className="key_slider-container centerdot centerbar">
                <div className="key_range" />
                <div className="key_vbar" />
                <div className="key_rangeBar" />
              </div>
            </div>
            <div className="slider_legendscore ">
              The range of possible values. Bars represent the school's floor
              and targets.
            </div>
          </div>
          <div className="col-3 centerbox dot">
            <div className="centerdot">
              <div className="sliderKeyButton gray" />
            </div>
            <div className="slider_legendscore">
              The original value
              <br />
              of the score
            </div>
          </div>
          <div className="col-3 centerbox dot">
            <div className="centerdot">
              <div className="sliderKeyButton" />
            </div>
            <div className="slider_legendscore ">
              The projected value
              <br />
              of the score
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SliderKey;
